<mat-vertical-stepper linear>
    <mat-step [stepControl]="vehicleForm">
        <form [formGroup]="vehicleForm">
            <ng-template matStepLabel>Vehicle</ng-template>
        </form>
    </mat-step>
    <mat-step [stepControl]="associateForm">
        <form [formGroup]="associateForm">
            <ng-template matStepLabel>Associate</ng-template>
        </form>
    </mat-step>
    <mat-step [stepControl]="appointmentForm">
        <form [formGroup]="appointmentForm">
            <ng-template matStepLabel>Appointment</ng-template>
        </form>
    </mat-step>
</mat-vertical-stepper>